/**
 * @generated SignedSource<<7d7d290513180196285675483000a649>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type GlobalLayoutContextQuery$variables = {};
export type GlobalLayoutContextQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"GlobalLayoutContextNavbarFragment">;
};
export type GlobalLayoutContextQuery = {
  response: GlobalLayoutContextQuery$data;
  variables: GlobalLayoutContextQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dbid",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "GlobalLayoutContextQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "GlobalLayoutContextNavbarFragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "GlobalLayoutContextQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "GalleryUser",
                "kind": "LinkedField",
                "name": "user",
                "plural": false,
                "selections": [
                  (v0/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "username",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "bio",
                    "storageKey": null
                  },
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Wallet",
                    "kind": "LinkedField",
                    "name": "wallets",
                    "plural": true,
                    "selections": [
                      (v0/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ChainAddress",
                        "kind": "LinkedField",
                        "name": "chainAddress",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "address",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "chain",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v1/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ViewerGallery",
                "kind": "LinkedField",
                "name": "viewerGalleries",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Gallery",
                    "kind": "LinkedField",
                    "name": "gallery",
                    "plural": false,
                    "selections": [
                      (v0/*: any*/),
                      (v1/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "Viewer",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "9dd02e44617d38cee078f66afc6988a7",
    "id": null,
    "metadata": {},
    "name": "GlobalLayoutContextQuery",
    "operationKind": "query",
    "text": "query GlobalLayoutContextQuery {\n  ...GlobalLayoutContextNavbarFragment\n}\n\nfragment EditUserInfoModalFragment on Query {\n  viewer {\n    __typename\n    ... on Viewer {\n      user {\n        dbid\n        username\n        bio\n        id\n      }\n    }\n  }\n}\n\nfragment GlobalBannerFragment on Query {\n  viewer {\n    __typename\n    ... on Viewer {\n      user {\n        id\n      }\n    }\n  }\n}\n\nfragment GlobalLayoutContextNavbarFragment on Query {\n  ...GlobalNavbarFragment\n  ...GlobalBannerFragment\n  ...isFeatureEnabledFragment\n}\n\nfragment GlobalNavbarFragment on Query {\n  ...RightContentFragment\n}\n\nfragment LoggedInNavFragment on Query {\n  ...EditUserInfoModalFragment\n  ...ManageWalletsModalFragment\n  ...isFeatureEnabledFragment\n  viewer {\n    __typename\n    ... on Viewer {\n      user {\n        username\n        id\n      }\n      viewerGalleries {\n        gallery {\n          dbid\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment ManageWalletsFragment on Query {\n  viewer {\n    __typename\n    ... on Viewer {\n      user {\n        wallets {\n          dbid\n          chainAddress {\n            address\n            chain\n          }\n          id\n        }\n        id\n      }\n    }\n  }\n}\n\nfragment ManageWalletsModalFragment on Query {\n  ...ManageWalletsFragment\n}\n\nfragment RightContentFragment on Query {\n  ...LoggedInNavFragment\n  viewer {\n    __typename\n    ... on Viewer {\n      user {\n        id\n      }\n    }\n  }\n}\n\nfragment isFeatureEnabledFragment on Query {\n  viewer {\n    __typename\n    ... on Viewer {\n      user {\n        dbid\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "80fa08ca6b39235fb9ff091c1ea72055";

export default node;
